const readCache = (key) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.expiresAt !== 'number') return null;
    if (Date.now() > parsed.expiresAt) {
      localStorage.removeItem(key);
      return null;
    }
    return parsed.value;
  } catch {
    return null;
  }
};

const writeCache = (key, value, ttl) => {
  try {
    localStorage.setItem(key, JSON.stringify({ value, expiresAt: Date.now() + ttl }));
  } catch {
    // Quota exceeded or storage disabled — silently skip.
  }
};

const pending = new Map();

export const cachedFetch = async (key, ttl, fetcher) => {
  const cached = readCache(key);
  if (cached !== null) return cached;
  if (pending.has(key)) return pending.get(key);

  const promise = (async () => {
    try {
      const value = await fetcher();
      if (value != null) writeCache(key, value, ttl);
      return value;
    } finally {
      pending.delete(key);
    }
  })();
  pending.set(key, promise);
  return promise;
};
